<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-body pt-2 px-2">
        <div class="row mb-075 justify-content-sm-between justify-content-xl-start">
          <div class="col-md-3 col-12">
            <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="filter_string" (ngModelChange)="getItems(); changeQueryParams()" />
          </div>
          <div class="col-md-3 col-12 offset-md-6 text-md-right">
            <div class="d-md-inline-block mr-2" *ngIf="_utilService.isDesktop">
              <app-select-table-limit (onChange)="tableLimit = $event" [defaultValue]="tableLimit"></app-select-table-limit>
            </div>
            <button type="button" class="btn btn-outline-primary" has_capability="export_employee_planning" (click)="exportExcel()">{{ 'EXPORT_EXCEL' | translate }}</button>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-3 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
            <ng-select [(ngModel)]="filter_customer" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="getItems(); changeQueryParams()">
              <ng-option [value]="0">
                <span class="font-small-4 font-weight-normal pr-2">{{ "CUSTOMER" | translate }}</span>
              </ng-option>
              <ng-option [value]="customer.id" *ngFor="let customer of customers">
                <span class="font-small-4 font-weight-normal pr-2">{{ customer.name }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-md-3 col-12" ngClass.sm="mb-1">
            <ng-select class="w-100" id="figure" [(ngModel)]="filter_figure" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="filter_figure > 0" (clear)="filter_figure = 0" (ngModelChange)="getItems(); changeQueryParams()">
              <ng-option [value]="0">
                <span class="font-small-4 font-weight-normal">{{ "ALL_FIGURES" | translate }}</span>
              </ng-option>
              <ng-option *ngFor="let figure of _userFigureService.list" [value]="figure.id">
                <span class="font-small-4 font-weight-normal">{{ figure.name }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-md-3 col-12" ngClass.sm="mb-1">
            <ng-select id="skill-filter"
                       [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true"
                       [multiple]="true" [(ngModel)]="filter_skill" (clear)="filter_skill = [0]" (ngModelChange)="changeSkill(); changeQueryParams()">
              <ng-option [value]="0">
                <div class="font-small-4 font-weight-normal">{{ "ALL_SKILLS" | translate }}</div>
              </ng-option>
              <ng-option *ngFor="let skill of _skillService.list_enabled" [value]="skill.id">
                <span class="font-small-4 font-weight-normal">{{ skill.name }}</span>
              </ng-option>
              <ng-template ng-multi-label-tmp let-items="items" *ngIf="filter_skill.includes(0)">
                <div class="ng-select-selected-items">
                  <div *ngFor="let item of items; let last = last">
                    <div class="ng-value" *ngIf="item > 0">
                      <span>{{ item }}</span><span *ngIf="!last">, </span>
                    </div>
                  </div>
                  <div class="font-small-4 font-weight-normal" [style.margin-top.px]="-5">{{ "ALL_SKILLS" | translate }}</div>
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="card-body px-0 pt-0 overflow-hidden">
        <ngx-datatable
          #table
          class="bootstrap core-bootstrap material expandable"
          columnMode="force"
          [headerHeight]="50"
          [scrollbarH]="true"
          [rowHeight]="filter_skill.includes(0) && _utilService.isDesktop ? 70 : 165"
          [limit]="tableLimit"
          [footerHeight]="50"
          [rows]="userFiltered"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate), totalMessage: ('TOTAL' | translate).toLowerCase() }"
          [offset]="pageNumber"
          (page)="setPage($event)"
        >
          <!-- Row Detail Template -->
          <ngx-datatable-row-detail [rowHeight]="0" #myDetailRow>
            <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
              <div class="child-datatable">
                <!--  <div class="row" *ngFor="let child of row.children; let i = index" [ngClass]="i < row.children.length - 1 ? 'mb-1' : ''"> -->
                <div class="row mb-1" *ngIf="_utilService.isDesktop">
                  <div class="col-lg-3 pr-0 font-weight-bold">{{ "CUSTOMER" | translate }}</div>
                  <div class="col-lg-3 px-0 font-weight-bold">{{ "COMMISSION" | translate }}</div>
                  <div class="col-lg-2 pl-0 font-weight-bold">{{ "RATE" | translate }}</div>
                  <div class="col-lg-2 pl-0 font-weight-bold">{{ "EXPIRE_DATE" | translate }}</div>
                </div>
                <div class="row" *ngFor="let commission of row.commissions; let i = index" [ngClass]="i < row.commissions.length - 1 ? 'mb-1' : ''">
                  <a class="col-lg-3 pr-0" ngClass.sm="px-0" target="_blank" [ngbTooltip]="commission.commission.client.name" [routerLink]="'/dashboard/customer/' + commission.commission.client.id">{{
                      commission.commission.client.name
                    }}</a>
                  <div class="col-lg-3 px-0 d-flex align-items-center">
                    <a class="ext-break-line-2" target="_blank" [ngbTooltip]="commission.commission.name" [routerLink]="'/dashboard/commission/edit/' + commission.commission.id">{{
                        commission.commission.name ? commission.commission.name : "-"
                      }}</a>
                    <span *ngIf="commission.detachment_type">
                      <i [data-feather]="'repeat'" size="15"></i>
                    </span>
                    <span class="ml-075" *ngIf="commission.type =='time_material'" [ngbTooltip]="'TIME_MATERIAL' | translate"><i [data-feather]="'clock'" size="15"></i></span>
                    <span class="ml-075" *ngIf="commission.type =='task'" [ngbTooltip]="'TASK' | translate"> <i [data-feather]="'calendar'" size="15"></i></span>
                  </div>

                  <div class="col-lg-2 pl-0">{{ commission.rate }} &euro;</div>
                  <div class="col-lg-2 pl-0">{{ commission.end_date | date: "dd/MM/yyyy" }}</div>
                </div>
                <div class="row" *ngFor="let structure of row.structures; let i = index" [ngClass]="i < row.commissions.length - 1 ? 'mb-1' : ''">
                  <div class="col-lg-3 pr-0 text-primary" ngClass.sm="px-0">{{ _utilService.themeConfiguration.company_nicename }}</div>
                  <a class="col-lg-3 px-0" target="_blank" routerLink="/dashboard/costs/structure-cost-list">{{ structure.description }}</a>
                  <div class="col-lg-2 pl-0">- &euro;</div>
                  <div class="col-lg-2 pl-0">{{ structure.end_date | date: "dd/MM/yyyy" }}</div>
                </div>
              </div>
              <!-- </div> -->
            </ng-template>
          </ngx-datatable-row-detail>

          <!-- Column Templates -->
          <ngx-datatable-column [width]="50" [resizeable]="false" [sortable]="false" [draggable]="false" [canAutoResize]="false">
            <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
              <a
                *ngIf="(row.commissions && row.commissions.length > 0) || (row.structures && row.structures.length > 0)"
                href="javascript:void(0)"
                [class.datatable-icon-right]="!expanded"
                [class.datatable-icon-down]="expanded"
                title="Expand/Collapse Row"
                (click)="toggleExpandRow(row, expanded)"
              >
              </a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'NAME' | translate" prop="complete_name" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <div class="cell-line-height">
                  <a routerLink="/dashboard/user/profile/{{ row.hash }}">{{ row.complete_name }} </a>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'FIGURE' | translate" prop="figure_name" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <div>{{ row.figure_name || "" }}</div>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'SKILLS' | translate" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div *ngFor="let skill of filterSkillsForCandidate(row.skills)">
                <div class="badge badge-pill" [ngbTooltip]="skill.level | titlecase" placement="top" [ngClass]="{'badge-light-dark': skill.level === 'junior', 'badge-info' : skill.level === 'middle', 'badge-success': skill.level === 'senior'}">
                  {{ skill.name }}
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TOTAL_DAILY' | translate" prop="cost_total_daily" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <div>{{ _utilService.addDotsToNumber(row.cost_total_daily || "0") }} &euro;</div>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'PROFILE_LAST_UPDATE_DATE' | translate" prop="update_date" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <div>{{ row.update_date | date: "dd/MM/yyyy" }}</div>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'FIRSTNAME_AND_LASTNAME' | translate" prop="firstname" [sortable]="true" [width]="300" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-12 mb-075">
                  <a routerLink="/dashboard/user/profile/{{ row.hash }}">{{ row.complete_name }} </a>
                  <div>{{ row.figure_name || "" }}</div>
                </div>
                <div class="col-12 d-flex flex-wrap mb-075">
                  <div *ngFor="let skill of filterSkillsForCandidate(row.skills)">
                    <div
                      class="badge badge-pill mr-1"
                      [ngbTooltip]="_utilService.ucFirst(skill.level)"
                      placement="top"
                      [ngClass]="skill.level === 'junior' ? 'badge-light-dark' : skill.level === 'middle' ? 'badge-info' : 'badge-success'"
                    >
                      {{ skill.name }}
                    </div>
                  </div>
                </div>
                <div class="col-12 mb-075">
                  <div>{{ "TOTAL_DAILY" | translate }}: {{ _utilService.addDotsToNumber(row.cost_total_daily || "0") }} &euro;</div>
                  <div>{{ "LAST_UPDATE_DATE" | translate }}: {{ row.update_date | date: "dd/MM/yyyy" }}</div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>
